export const Types = {
    GET_EQ_MAIN_LIST_BY_AREA: "GET_EQ_MAIN_LIST_BY_AREA",
    GET_EQUIPMENT_SUBLIST_BY_ID: "GET_EQUIPMENT_SUBLIST_BY_ID",
    GET_EQUIPMENT_BY_BAR_CODE: "GET_EQUIPMENT_BY_BAR_CODE",

    SET_EQ_MAIN_LIST_BY_AREA: "SET_EQ_MAIN_LIST_BY_AREA",
    SET_EQUIPMENT_SUBLIST_BY_ID: "SET_EQUIPMENT_SUBLIST_BY_ID",
    SET_EQUIPMENT_BY_BAR_CODE: "SET_EQUIPMENT_BY_BAR_CODE",
    DOWNLOAD_EXCEL_FILE: "DOWNLOAD_EXCEL_FILE",
    //haris
    GET_EQ_DETAIL_LIST: "GET_EQ_DETAIL_LIST",
    SET_EQ_DETAIL_LIST: "SET_EQ_DETAIL_LIST",
    GET_EQ_DETAIL_BY_ID: "GET_EQ_DETAIL_BY_ID",
    SET_EQ_DETAIL_BY_ID: "SET_EQ_DETAIL_BY_ID",
    DELETE_EQUIPMENT: "DELETE_EQUIPMENT",
    DELETE_EQUIPMENT_RES: "DELETE_EQUIPMENT_RES",
    GET_EQ_REPORT_GROUP_LIST: "GET_EQ_REPORT_GROUP_LIST",
    SET_EQ_REPORT_GROUP_LIST: "SET_EQ_REPORT_GROUP_LIST",
    RESET_EQ_GROUP: "RESET_EQ_GROUP",
    GET_EDIT_GROUP_INFO: "GET_EDIT_GROUP_INFO",
    SET_EDIT_GROUP_INFO: "SET_EDIT_GROUP_INFO",
    RESET_EDIT_GROUP_INFO: "RESET_EDIT_GROUP_INFO",
    GET_AREA_FOR_EQ: "GET_AREA_FOR_EQ",
    SET_AREA_FOR_EQ: "SET_AREA_FOR_EQ",
    GET_COST_CENTER_FOR_EQ: "GET_COST_CENTER_FOR_EQ",
    SET_COST_CENTER_FOR_EQ: "SET_COST_CENTER_FOR_EQ",
    GET_PLANT_LIST: "GET_PLANT_LIST",
    SET_PLANT_LIST: "SET_PLANT_LIST",
    GET_EQ_TYPES: "GET_EQ_TYPES",
    SET_EQ_TYPES: "SET_EQ_TYPES",
    RESET_EQ_MAIN_LIST: "RESET_EQ_MAIN_LIST",
    GET_EQ_MAIN_LIST: "GET_EQ_MAIN_LIST",
    SET_EQ_MAIN_LIST: "SET_EQ_MAIN_LIST",
    GET_EDIT_EQUIPMENT: "GET_EDIT_EQUIPMENT",
    SET_EDIT_EQUIPMENT: "SET_EDIT_EQUIPMENT",
    GET_ADD_EQUIPMENT: "GET_ADD_EQUIPMENT",
    SET_ADD_EQUIPMENT: "SET_ADD_EQUIPMENT",
    GET_EQUIPMENT_REPORT_GROUP_BY_ID: "GET_EQUIPMENT_REPORT_GROUP_BY_ID",
    SET_EQUIPMENT_REPORT_GROUP_BY_ID: "SET_EQUIPMENT_REPORT_GROUP_BY_ID",
    RESET_DELETED_EQ: "RESET_DELETED_EQ",
    RESET_DETAIL_LIST: "RESET_DETAIL_LIST",
    RESET_EQ_RES: "RESET_EQ_RES",
    EQ_MAIN_LIST_BY_AREA_FAILURE: "EQ_MAIN_LIST_BY_AREA_FAILURE",

    GET_EQUIPMENT_FILES: "GET_EQUIPMENT_FILES",
    SET_EQUIPMENT_FILES: "SET_EQUIPMENT_FILES",
    ADD_EQUIPMENT_FILES: "ADD_EQUIPMENT_FILES",
    DELETE_EQUIPMENT_FILES: "DELETE_EQUIPMENT_FILES",
};

export const downloadExcelFile = () => ({
    type: Types.DOWNLOAD_EXCEL_FILE,
});

export const getEqGetMainListByAreaID = (payload) => ({
    type: Types.GET_EQ_MAIN_LIST_BY_AREA,
    payload,
});
export const setEqGetMainListByAreaID = (payload) => ({
    type: Types.SET_EQ_MAIN_LIST_BY_AREA,
    payload,
});
export const eqGetMainListByAreaIDFailure = (payload) => ({
    type: Types.EQ_MAIN_LIST_BY_AREA_FAILURE,
    payload,
});
export const getEqGetSubListById = (payload) => ({
    type: Types.GET_EQUIPMENT_SUBLIST_BY_ID,
    payload,
});
export const setEqGetSubListById = (payload) => ({
    type: Types.SET_EQUIPMENT_SUBLIST_BY_ID,
    payload,
});
export const getEqGetByBarcodeContext = (payload) => ({
    type: Types.GET_EQUIPMENT_BY_BAR_CODE,
    payload,
});
export const setEqGetByBarcodeContext = (payload) => ({
    type: Types.SET_EQUIPMENT_BY_BAR_CODE,
    payload,
});
export const getEqDetailList = (payload) => ({
    type: Types.GET_EQ_DETAIL_LIST,
    payload: payload,
});
export const setEqDetailList = (payload) => ({
    type: Types.SET_EQ_DETAIL_LIST,
    payload: payload,
});
export const deleteEquipment = (payload) => ({
    type: Types.DELETE_EQUIPMENT,
    payload: payload,
});
export const deleteEquipmentRes = (payload) => ({
    type: Types.DELETE_EQUIPMENT_RES,
    payload: payload,
});
export const getEquipmentDetailById = (payload) => ({
    type: Types.GET_EQ_DETAIL_BY_ID,
    payload: payload,
});
export const getEquipmentReportList = () => ({
    type: Types.GET_EQ_REPORT_GROUP_LIST,
});
export const setEquipmentReportList = (payload) => ({
    type: Types.SET_EQ_REPORT_GROUP_LIST,
    payload: payload,
});
export const setEquipmentDetailById = (payload) => ({
    type: Types.SET_EQ_DETAIL_BY_ID,
    payload: payload,
});
export const getEquipmentReportGroupById = (payload) => ({
    type: Types.GET_EQUIPMENT_REPORT_GROUP_BY_ID,
    payload: payload,
});
export const setEquipmentReportGroupById = (payload) => ({
    type: Types.SET_EQUIPMENT_REPORT_GROUP_BY_ID,
    payload: payload,
});
export const editEquipmentGroupInfo = (payload) => ({
    type: Types.GET_EDIT_GROUP_INFO,
    payload: payload,
});
export const setEditEquipmentGroupInfo = (payload) => ({
    type: Types.SET_EDIT_GROUP_INFO,
    payload: payload,
});
export const resetEqGroup = () => ({
    type: Types.RESET_EQ_GROUP,
});
export const setEqDetailListEmpty = () => ({
    type: Types.RESET_DETAIL_LIST,
});
// Edit Equipment
export const getAreaList = () => ({
    type: Types.GET_AREA_FOR_EQ,
});
export const setAreaList = (payload) => ({
    type: Types.SET_AREA_FOR_EQ,
    payload: payload,
});
export const getCostCenterList = () => ({
    type: Types.GET_COST_CENTER_FOR_EQ,
});
export const setCostCenterList = (payload) => ({
    type: Types.SET_COST_CENTER_FOR_EQ,
    payload: payload,
});
export const getPlantList = () => ({
    type: Types.GET_PLANT_LIST,
});
export const setPlantList = (payload) => ({
    type: Types.SET_PLANT_LIST,
    payload: payload,
});
export const getEquipmentTypeList = () => ({
    type: Types.GET_EQ_TYPES,
});
export const setEquipmentTypeList = (payload) => ({
    type: Types.SET_EQ_TYPES,
    payload: payload,
});
export const getEqMainList = (payload) => ({
    type: Types.GET_EQ_MAIN_LIST,
    payload: payload,
});
export const setEqMainList = (payload) => ({
    type: Types.SET_EQ_MAIN_LIST,
    payload: payload,
});
export const getEditEquipment = (payload) => ({
    type: Types.GET_EDIT_EQUIPMENT,
    payload: payload,
});
export const setEditEquipment = (payload) => ({
    type: Types.SET_EDIT_EQUIPMENT,
    payload: payload,
});
export const getAddEquipment = (payload) => ({
    type: Types.GET_ADD_EQUIPMENT,
    payload: payload,
});
export const setAddEquipment = (payload) => ({
    type: Types.SET_ADD_EQUIPMENT,
    payload: payload,
});
export const resetEqRes = () => ({
    type: Types.RESET_EQ_RES,
});
export const resetDelEq = () => ({
    type: Types.RESET_DELETED_EQ,
});
export const resetEqMainList = () => ({
    type: Types.RESET_EQ_MAIN_LIST,
});
export const resetEditedGroupInfo = () => ({
    type: Types.RESET_EDIT_GROUP_INFO,
});

export const getEquipmentFiles = (payload) => ({
    type: Types.GET_EQUIPMENT_FILES,
    payload: payload,
});

export const setEquipmentFiles = (payload) => ({
    type: Types.SET_EQUIPMENT_FILES,
    payload: payload,
});

export const addEquipmentFiles = (payload) => ({
    type: Types.ADD_EQUIPMENT_FILES,
    payload: payload,
});

export const deleteEquipmentFiles = (payload) => ({
    type: Types.DELETE_EQUIPMENT_FILES,
    payload: payload,
});
